import { ExamCenterExamCourseList } from '@exam-center/admin-exam-center-exam-course-list';
import { AssignExamCourseButton } from '@exam-center/exam-center-exam-course-assignment';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamCenterExamCourseListPage() {
  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW}
    >
      <PaperSection
        title='หลักสูตรที่เปิดสอบ'
        sx={{ height: '100%' }}
        endAdornment={<AssignExamCourseButton />}
      >
        <Box sx={{ p: (theme) => theme.spacing(6), height: '100%' }}>
          <ExamCenterExamCourseList />
        </Box>
      </PaperSection>
    </PermissionGuard>
  );
}
